// https://fontawesome.com/search?q=
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDumbbell } from "@fortawesome/free-solid-svg-icons";
import {
  faFutbol,
  faBasketball,
  faRobot,
  faShield,
  faMosque,
  faSeedling,
  faGift,
  faNetworkWired,
  faMoneyCheckDollar,
  faGlobe,
  faBus,
  faScissors,
  faFileInvoiceDollar,
  faFileInvoice,
  faPaw,
  faBook,
  faHatCowboy,
  faUserSecret,
  faFileShield,
  faTrophy,
  faBroom,
  faComment,
  faPizzaSlice,
  faVault,
  faShirt,
  faEye,
  faCamera
} from "@fortawesome/free-solid-svg-icons";

// import { faHatChef } from '@fortawesome/sharp-solid-svg-icons'

import { faGamepad } from "@fortawesome/free-solid-svg-icons";

import "./navbar.css";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import SessionContext from "../session/SessionContext";

const SuperAdminSidebar = () => {
  const {
    actions: { signout },
  } = useContext(SessionContext);
  return (
    <div
      className=" border-right h-100 "
      id="sidebar"
      style={{
        width: "250px",
        padding: "0 10px",
        position: "fixed",
        top: "81px",
        left: "0",
        zIndex: "9999",
        backgroundColor: "#fff",
        overflow: "auto",
        paddingBottom: "50px",
      }}
    >
      <ul className="list-unstyled ">
        {/* <NavLink to={"storeapproval"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGlobe} className="text-primary me-2" />
              Stores
            </p>
          </li>
        </NavLink>
        <NavLink to={"categories"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGlobe} className="text-primary me-2" />
              Categories
            </p>
          </li>
        </NavLink>
        <NavLink to={"store"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGlobe} className="text-primary me-2" />
              Store
            </p>
          </li>
        </NavLink> */}

        <NavLink to={"appleAccounts"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGlobe} className="text-primary me-2" />
              Apple Accounts
            </p>
          </li>
        </NavLink>

        <NavLink to={"services"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGlobe} className="text-primary me-2" />
              Landing Pages
            </p>
          </li>
        </NavLink>

        <NavLink to={"advertisement"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGlobe} className="text-primary me-2" />
              Advertising
            </p>
          </li>
        </NavLink>

        <NavLink to={"billableposted"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faMoneyCheckDollar}
                className="text-primary me-2"
              />
              Billable Posted
            </p>
          </li>
        </NavLink>

        <NavLink to={"nonbillableposted"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faMoneyCheckDollar}
                className="text-primary me-2"
              />
              Non-Billable Posted
            </p>
          </li>
        </NavLink>

        {/* <NavLink to={"billablepostedbynetwork"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faMoneyCheckDollar}
                className="text-primary me-2"
              />
              Billable Posted By Network
            </p>
          </li>
        </NavLink> */}

        <NavLink to={"advertisingnetwork"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faNetworkWired}
                className="text-primary me-2"
              />
              Advertising Networks
            </p>
          </li>
        </NavLink>

        {/* <NavLink to={"AdvertisingInvoices"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faFileInvoiceDollar}
                className="text-primary me-2"
              />
              Advertising Invoices
            </p>
          </li>
        </NavLink> */}

        {/* <NavLink to={"AdvertisingOffers"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faFileInvoiceDollar}
                className="text-primary me-2"
              />
              Advertising Offers
            </p>
          </li>
        </NavLink> */}

        <NavLink to={"AdvertisingBillablePosted"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faFileInvoiceDollar}
                className="text-primary me-2"
              />
              Advertising Billable Posted
            </p>
          </li>
        </NavLink>

        <NavLink to={"AdvertisingNonBillablePosted"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faFileInvoiceDollar}
                className="text-primary me-2"
              />
              Advert Non-Billable Posted
            </p>
          </li>
        </NavLink>


        <NavLink to={"vibelytics"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faRobot} className="text-primary me-2" />
              Vibelytics SA
            </p>
          </li>
        </NavLink>

        <NavLink to={"vibelyticsdu"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faRobot} className="text-primary me-2" />
              Vibelytics AE DU
            </p>
          </li>
        </NavLink>

        <NavLink to={"stylistsa"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faShirt} className="text-primary me-2" />
              AI-Stylist SA
            </p>
          </li>
        </NavLink>

        <NavLink to={"stylistkw"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faShirt} className="text-primary me-2" />
              AI-Stylist KW
            </p>
          </li>
        </NavLink>

        <NavLink to={"katcha"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faCamera} className="text-primary me-2" />
              Katcha
            </p>
          </li>
        </NavLink>

        <NavLink to={"eyetest"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faEye} className="text-primary me-2" />
              EyeTest
            </p>
          </li>
        </NavLink>

        <NavLink to={"mobivaultidex"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faVault} className="text-primary me-2" />
              MobiVault Idex
            </p>
          </li>
        </NavLink>

        <NavLink to={"foodigoidex"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faPizzaSlice} className="text-primary me-2" />
              Foodigo Idex
            </p>
          </li>
        </NavLink>

        <NavLink to={"bnfootball"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faFutbol} className="text-primary me-2" />
              BnFootball
            </p>
          </li>
        </NavLink>

        <NavLink to={"koraclubtimwe"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faFutbol} className="text-primary me-2" />
              KoraClub TimWe
            </p>
          </li>
        </NavLink>

        <NavLink to={"converseaitimwe"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faComment} className="text-primary me-2" />
              ConverseAI TimWe
            </p>
          </li>
        </NavLink>

        <NavLink to={"chefrecipestimwe"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faPizzaSlice} className="text-primary me-2" />
              ChefRecipes TimWe
            </p>
          </li>
        </NavLink>

        <NavLink to={"scoretimwe"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faBasketball} className="text-primary me-2" />
              Score TimWe
            </p>
          </li>
        </NavLink>
        <NavLink to={"beautytimwe"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faScissors} className="text-primary me-2" />
              Beauty TimWe
            </p>
          </li>
        </NavLink>
        <NavLink to={"assistanttimwe"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faRobot} className="text-primary me-2" />
              Assistant TimWe
            </p>
          </li>
        </NavLink>


        <NavLink to={"extratime"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faFutbol} className="text-primary me-2" />
              ExtraTime365
            </p>
          </li>
        </NavLink>

        <NavLink to={"shootkoora"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faFutbol} className="text-primary me-2" />
              Shoot Koora
            </p>
          </li>
        </NavLink>

        <NavLink to={"filesguard"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faShield} className="text-primary me-2" />
              FilesGuard
            </p>
          </li>
        </NavLink>

        <NavLink to={"filesheild"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faShield} className="text-primary me-2" />
              FileSheild
            </p>
          </li>
        </NavLink>

        <NavLink to={"sheild"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faFileShield}
                className="text-primary me-2"
              />
              Sheild 3ANET
            </p>
          </li>
        </NavLink>

        <NavLink to={"gamesportal"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGamepad} className="text-primary me-2" />
              GamesPortal
            </p>
          </li>
        </NavLink>

        <NavLink to={"gombsgom"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGamepad} className="text-primary me-2" />
              GomBsGom
            </p>
          </li>
        </NavLink>
        <NavLink to={"gymnslim"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faDumbbell}
                className="text-primary me-2"
              />
              GymNSLim
            </p>
          </li>
        </NavLink>
        <NavLink to={"islamicnote"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faMosque} className="text-primary me-2" />
              IslamicNote
            </p>
          </li>
        </NavLink>
        <NavLink to={"alsirat"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faMosque} className="text-primary me-2" />
              Al Sirat
            </p>
          </li>
        </NavLink>
        <NavLink to={"plantid"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faSeedling} className="text-primary me-2" />
              PlantId
            </p>
          </li>
        </NavLink>
        <NavLink to={"womencare"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faScissors} className="text-primary me-2" />
              Women Care
            </p>
          </li>
        </NavLink>
        <NavLink to={"foodrecipes"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faHatCowboy} className="text-primary me-2" />
              Food Recipes
            </p>
          </li>
        </NavLink>
        <NavLink to={"islamicreminder"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faMosque} className="text-primary me-2" />
              Islamic Reminder
            </p>
          </li>
        </NavLink>
        <NavLink to={"koraclub"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faFutbol} className="text-primary me-2" />
              KoraClub
            </p>
          </li>
        </NavLink>



        <NavLink to={"mobileboxes"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faGift} className="text-primary me-2" />
              MobileBoxes
            </p>
          </li>
        </NavLink>
        <NavLink to={"mobofort"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faShield} className="text-primary me-2" />
              Mobofort
            </p>
          </li>
        </NavLink>
        <NavLink to={"muslimsgate"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faMosque} className="text-primary me-2" />
              MuslimsGate
            </p>
          </li>
        </NavLink>
        <NavLink to={"islamnquran"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faMosque} className="text-primary me-2" />
              IslamNQuran
            </p>
          </li>
        </NavLink>
        <NavLink to={"smsmapp"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faShield} className="text-primary me-2" />
              SmsmApp
            </p>
          </li>
        </NavLink>
        <NavLink to={"vipgym"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faDumbbell}
                className="text-primary me-2"
              />
              VipGym
            </p>
          </li>
        </NavLink>
        <NavLink to={"whatsfile"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faShield} className="text-primary me-2" />
              WhatsFile
            </p>
          </li>
        </NavLink>

        <NavLink to={"dailybeauty"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faScissors}
                className="text-primary me-2"
              />
              Daily Beauty
            </p>
          </li>
        </NavLink>

        <NavLink to={"kidspreschool"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faBus} className="text-primary me-2" />
              KidsPreSchool
            </p>
          </li>
        </NavLink>

        <NavLink to={"pets"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faPaw} className="text-primary me-2" />
              Pets
            </p>
          </li>
        </NavLink>

        <NavLink to={"oxford"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon icon={faBook} className="text-primary me-2" />
              Oxford
            </p>
          </li>
        </NavLink>

        <NavLink to={"chefRecipes"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faHatCowboy}
                className="text-primary me-2"
              />
              ChefRecipes
            </p>
          </li>
        </NavLink>
        <NavLink to={"securesafe"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faUserSecret}
                className="text-primary me-2"
              />
              SecureSafe
            </p>
          </li>
        </NavLink>
        <NavLink to={"subAndWin"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faTrophy}
                className="text-primary me-2"
              />
              SubAndWin
            </p>
          </li>
        </NavLink>
        <NavLink to={"phoneCleaner"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faBroom} beat
                className="text-primary me-2"
              />
              Phone Cleaner
            </p>
          </li>
        </NavLink>
        <NavLink to={"converseAI"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faComment} fade
                className="text-primary me-2"
              />
              Converse AI
            </p>
          </li>
        </NavLink>

        {/* <NavLink to={"stickyNote"}>
          <li className="py-2 ">
            <p className="text-dark pl-3 font-weight-bold pt-1" href="#">
              <FontAwesomeIcon
                icon={faComment} fade
                className="text-primary me-2"
              />
              Sticky Note
            </p>
          </li>
        </NavLink> */}
      </ul>
      <button className="btn btn-dark mb-5 ml-4 " onClick={signout}>
        LOGOUT
      </button>
    </div>
  );
};

export default SuperAdminSidebar;
